<template>
  <vx-tooltip text="Завершить чат">
    <button
      :disabled="!currentClient.is_assigned_by_you"
      class="messenger-close-button"
      @click.prevent="handleEndChat"
    >
      <feather-icon
        icon="XIcon"
      />
    </button>
  </vx-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'
import Client from '@/api/http/models/Client'

export default {
  computed: mapGetters(['currentClient',  'authUserCompany']),

  methods: {
    handleEndChat () {
      const end = async () => {
        const response = await Client.closeSession(this.authUserCompany.slug, this.currentClient.client_id)

        if (response.status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Чат успешно завершен'
          })
        }
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Завершить чат?',
        text: `Вы уверены, что хотите завершить чат с текущем клиентом «${this.currentClient.name}»?`,
        accept: end,
        acceptText: 'Завершить',
        cancelText: 'Отменить'
      })
    }
  }
}
</script>
